import { ShadePickerMode } from '@ori-events/open-shade-picker';
import { createContext, useContext } from 'react';
export const defaulShadePickerContext = {
  mode: ShadePickerMode.QuickBuy,
  goToUrl: '',
  productCode: ''
};
export const shadePicker = /*#__PURE__*/createContext(defaulShadePickerContext);
export const ShadePickerProvider = shadePicker.Provider;
export const useShadePicker = () => useContext(shadePicker);
//# sourceMappingURL=shadePickerContext.js.map